import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminAiPromptRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/ai_prompt',
}).lazy(() =>
  import('pages/admin/AiPrompt/AdminAiPromptPage/AdminAiPromptPage').then((d) => d.Route)
);
